import ContactForm from "@/components/ContactForm";
import { Reveal } from "@/components/Reveal";
import { useTitle } from "@/hooks/use-title";

export default function Contact() {
  useTitle("Start a conversation — Operating Reality");
  return (
    <main className="pt-16 lg:pt-[72px]" data-testid="contact-page">
      <section className="relative overflow-hidden">
        <div className="bg-grid absolute inset-0 opacity-25" />
        <div className="wrap relative grid gap-16 py-24 lg:grid-cols-12 lg:py-36">
          <div className="lg:col-span-6">
            <Reveal>
              <p className="kicker">Contact</p>
              <h1 className="mt-6 text-balance text-4xl font-semibold leading-[1.08] tracking-tight text-slate-50 sm:text-5xl">
                Have a problem you can't quite explain?
              </h1>
              <p className="mt-8 max-w-md text-base leading-relaxed text-slate-400">
                If you know something isn't working but aren't sure whether the problem is
                process, people, technology or governance — that's exactly the right starting
                point. Describe what's happening. Not what you think the solution is.
              </p>
              <div className="mt-12 space-y-3 border-l border-line/60 pl-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
                  No sales sequence
                </p>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
                  No discovery-call script
                </p>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
                  A considered reply
                </p>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-6">
            <Reveal delay={0.12}>
              <div className="border border-line/60 bg-charcoal/30 p-7 lg:p-10">
                <ContactForm />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
